import React from 'react';
import './About.css';

const About: React.FC = () => {
  return (
    <section className="about-section" id="about">
      <div className="about-container">
        <div className="about-content">
          <div className="about-image">
            <img 
              src="/Architecture Splash.jpg" 
              alt="Architecture visualization"
              className="about-architecture-image"
            />
          </div>
          
          <div className="about-text">
            <h2 className="about-title">About us</h2>
            <p>
              Every architectural project faces the same reality: critical knowledge gets lost amid shifting teams, endless emails and cluttered files. Important details, comments and regulations slip through the cracks. There's no central place to capture and digest the layers of architectural knowledge across the UK and key export regions.
            </p>
            
            <p>
              We founded Archaas because we've experienced this first-hand. Teams change, client correspondence gets forgotten and rework becomes routine. UK architects lose 9 hours a week to avoidable work, contributing to £21B+ in burnt fees annually, with 87% of projects delayed.
            </p>
            
            <p>
              Archaas is the AI-powered workspace that changes this.
            </p>
            
            <p>
              It learns your projects, practice standards and live team correspondence. It integrates with your existing tools and combines this knowledge with our live, clause-level global regulation database to check compliance against building codes and internal guidelines.
            </p>
            
            <p>
              No more scattered files. No more wasted hours. One intelligent platform to help architects move faster, reduce rework and protect fees from concept to approval.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 